import { FC } from 'react';

import { useAppSelector, useTax, useToChainWalletAddress } from '../hooks';
import { selectBridgeSlice } from '../redux/slices/bridgeSlice';
import Modal from './common/Modal/Modal';
import { floorToDecimals, roundToDecimals } from '../utils/calc';
import useToChainTokenFee from '../hooks/common/useToChainTokenFee';

interface ModalExchangeProps {
  isShow: boolean;
  onRequestClose: () => void;
  onAgree: () => void;
}

const ModalExchange: FC<ModalExchangeProps> = ({
  isShow,
  onRequestClose,
  onAgree,
}) => {
  const {
    selectedToken,
    selectedFromChain,
    selectedToChain,
    tokenTransferAmount,
  } = useAppSelector(selectBridgeSlice);

  const { taxRange, taxAmount } = useTax();
  const toChainTokenFee = useToChainTokenFee();
  const toChainWalletAddress = useToChainWalletAddress();
  // NOTE: 코인 토큰 동적으로 바꿔주기

  const formattedTax = roundToDecimals(taxAmount);
  const formattedFee = floorToDecimals(toChainTokenFee?.bridgeFee);
  const formattedFinalAmount = roundToDecimals(
    Number(tokenTransferAmount) - (Number(formattedTax) + Number(formattedFee)),
  );

  return (
    <Modal
      isShow={isShow}
      onClose={onRequestClose}
      title="Check the token to convert"
      explanation="Please carefully check the amount to convert, to chain and recipient address."
      footerComponent={
        <button
          id="btn-sending"
          className="btn btn-block btn-primary btn-lg"
          onClick={onAgree}
        >
          OK
        </button>
      }
    >
      <div className="exchange-coin">
        <div>
          <span>From</span>
          <img
            src={selectedFromChain?.logoUrl}
            className="i-blockchain"
            alt="from-chain"
          />
          <strong>{selectedFromChain?.name}</strong>
        </div>
        <div>
          <span>To</span>
          <img
            src={selectedToChain?.logoUrl}
            className="i-blockchain"
            alt="to-chain"
          />
          <strong>{selectedToChain?.name}</strong>
        </div>
      </div>
      <div className="exchange-detail">
        <div>
          <span>token to convert</span>
          <strong>{selectedToken?.name}</strong>
        </div>
        <div>
          <span>Tax</span>
          <strong>{`${formattedTax} ${selectedToken?.name}`}</strong>
        </div>
        <div>
          <span>Bridge fee</span>
          <strong>{`${formattedFee} ${selectedToken?.name}`}</strong>
        </div>
        <div>
          <span>amount to convert</span>
          <strong>{`${formattedFinalAmount} ${selectedToken?.name}`}</strong>
        </div>
      </div>
      <div className="exchange-address">
        <span>recipient address</span>
        <div className="wallet-name type-modal">
          <i data-icon="wallet" />
          {toChainWalletAddress}
        </div>
      </div>
      <ul className="caution">
        <li>
          When using an Ethereum network as a receiving chain or sending chain,
          contract needs to be confirmed in metamask. A nominal Ethereum fee
          will be incurred, so please prepare ETH in advance in your metamask,
          and if there is no ETH, the conversion cannot be processed.
        </li>
        <li>
          When the conversion begins, please go to the recipient wallet to check
          the balance and approve conversion.
        </li>
        <li>
          In the case of the same wallet, it is necessary to check the balance
          and approve conversion after changing the network.
        </li>
        <li>Press the OK button to approve the transfer between wallets.</li>
        <li style={{ color: `#C11A00` }}>
          {taxRange}% of transferring asset is charged as Tax,
          <br />
        </li>
      </ul>
    </Modal>
  );
};

export default ModalExchange;
